import React from "react"
import { createRoot } from "react-dom/client"
import { Badge, Btn, Icon } from "./groupssuite/ui"

function DomainsIndex({ domains, labels, canCreate, newPath }) {
  return (
    <section className="screen">
      <header className="screen__head">
        <div>
          <h1 className="screen__title">{labels.title}</h1>
          <p className="screen__subtitle">{labels.subtitle}</p>
        </div>
        {canCreate && <Btn variant="accent" icon="plus" href={newPath}>{labels.new}</Btn>}
      </header>

      <div className="domain-list">
        {domains.map((d) => (
          <a key={d.id} href={d.path} className="domain-row">
            <div className="domain-row__main">
              <div className="domain-row__name">{d.name}</div>
              <div className="domain-row__host">{d.host}</div>
            </div>
            <div className="domain-row__langs">
              {d.languages.map((l) => <Badge key={l}>{l.toUpperCase()}</Badge>)}
            </div>
            <div className="domain-row__goal">{d.default_goal || "–"}</div>
            <div className="domain-row__channels">{d.channels_count} {labels.channels_word}</div>
            <Icon name="chevron" size={16} color="var(--ink-faint)" />
          </a>
        ))}
      </div>
    </section>
  )
}

function mount() {
  const el = document.getElementById("domains-index")
  if (!el || el.dataset.mounted === "true") return
  let props = {}
  try {
    props = JSON.parse(el.dataset.props || "{}")
  } catch (error) {
    console.error("Invalid domains-index props", error)
  }
  el.dataset.mounted = "true"
  createRoot(el).render(<DomainsIndex {...props} />)
}

document.addEventListener("turbo:load", mount)
document.addEventListener("DOMContentLoaded", mount)
